/**
 * @flow
 * @relayHash 72d96453a09a8aaa290aaa59c92d09e9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type importCsvInput = {|
  clientMutationId?: ?string,
  propertyId: string,
  tempfile: string,
  emailColumn: string,
  firstNameColumn?: ?string,
  lastNameColumn?: ?string,
  fullNameColumn?: ?string,
|};
export type importCsvMutationVariables = {|
  input: importCsvInput
|};
export type importCsvMutationResponse = {|
  +importCsv: ?{|
    +importLog: ?{|
      +id: string,
      +createdAt: any,
      +fileName: string,
      +importedAt: ?any,
      +importedBy: string,
      +totalRows: number,
      +successCount: number,
      +failureCount: number,
      +contactsBeforeLoad: number,
      +contactsAfterLoad: number,
    |}
  |}
|};
export type importCsvMutation = {|
  variables: importCsvMutationVariables,
  response: importCsvMutationResponse,
|};
*/


/*
mutation importCsvMutation(
  $input: importCsvInput!
) {
  importCsv(input: $input) {
    importLog {
      id
      createdAt
      fileName
      importedAt
      importedBy
      totalRows
      successCount
      failureCount
      contactsBeforeLoad
      contactsAfterLoad
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "importCsvInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "importCsv",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "importCsvPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "importLog",
        "storageKey": null,
        "args": null,
        "concreteType": "ImportLog",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "importedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "importedBy",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalRows",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "successCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "failureCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactsBeforeLoad",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contactsAfterLoad",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "importCsvMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "importCsvMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "importCsvMutation",
    "id": null,
    "text": "mutation importCsvMutation(\n  $input: importCsvInput!\n) {\n  importCsv(input: $input) {\n    importLog {\n      id\n      createdAt\n      fileName\n      importedAt\n      importedBy\n      totalRows\n      successCount\n      failureCount\n      contactsBeforeLoad\n      contactsAfterLoad\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '517daf05dcbc2b71cdfe588d308340ed';
module.exports = node;
